export const capitalizeFirstLetter = (text = '') =>
  text.replace(/^\w/, (c) => c.toUpperCase())
